<template>
    <div>
        <p>
            RI DMV takes online security very seriously and authenticates every user, where possible, with Multi Factor Authentication (MFA).
            We do not seem to have a correct email and / or cell phone # on file for you to complete MFA electronically. To access your Online Customer Account profile you have the following options. Select one of the options and click 'Next'.
        </p>
        <div class="input-row" v-if="loginType == 1">
            <input type="radio" class="otp" id="otp-dd" name="otherDetails" v-model="mfaType" value="4" @change="errorMsg=''">
            <label class="otp-text" for="otp-dd">
                <p><strong>Option 1 Enter DD # from your License / ID card:</strong> If you have your RI License / ID Card with you, enter the DD # from the front of your license and you will be able to navigate
                you to your Online Customer Account profile page. With this option you will have not have access to few transactions. </p>
            </label>
        </div>
        <div class="input-row">
            <input type="radio" class="otp" id="otp-mail" name="otherDetails" v-model="mfaType" value="3" @change="errorMsg=''">
            <label class="otp-text" for="otp-mail">
              <p><strong>Option {{ loginType == 1 ? '2': '1' }} Send login code by mail:</strong> You can choose to receive a login code by mail. Once you receive the login code, please re-login on the online DMV Customer portal and you
              will be prompted to enter the login code. On successful validation of the login code you will be able to setup email and / or cell phone # on your record with RI DMV.<br />
              Please confirm if the following mailing address we have on file for you is correct. If this is correct, we will mail you a login code that will be valid for 30 days.</p>

              <span class="user-mail-address-heading">Mailing address on file</span>
              <div class="user-address">
                  <span>{{ contactInfo.mailingAddress.addressLine1 }} </span>
                  <span>{{ contactInfo.mailingAddress.addressLine2 }}</span>  
                  
                  <span>{{contactInfo.mailingAddress.city }},
                      {{ contactInfo.mailingAddress.addressType == 'Us Domestic'? 
                      contactInfo.mailingAddress.state : 
                      contactInfo.mailingAddress.province }}, 
                      {{ contactInfo.mailingAddress.country }}
                  </span>
                  <span>
                      {{ contactInfo.mailingAddress.addressType == 'Us Domestic' ?
                      contactInfo.mailingAddress.zipPlus == '' ?  contactInfo.mailingAddress.zipCode :
                      `${contactInfo.mailingAddress.zipCode} - ${contactInfo.mailingAddress.zipPlus}`
                      : `${contactInfo.mailingAddress.internationalZipCode}`
                      }}
                  </span>
              </div>
            </label>
        </div>
        <div class="input-row">
            <input type="radio" class="otp" id="otp-visit" name="otherDetails" value="DMV-visit" v-model="mfaType" @change="errorMsg=''">
            <label class="otp-text" for="otp-visit">
               <p><strong>Option {{ loginType == 1 ? '3': '2' }} Update Contact info on next DMV visit:</strong> You will not be able to access your Online Customer Account profile until you can be verified with Multi Factor Authentication (MFA).</p>
            </label>
        </div>

        <p v-if="errorMsg!=''" class="error-msg">
          {{ errorMsg }}
        </p>
        <p class="sr-only" v-if="errorMsg!=''">
          {{ errorMsg }}
        </p>

        <BaseButtonGroup>
            <button type="button" @click="handleRouting('previous')">Previous</button>
            <CustomButton type="submit" @click="handleRouting('next')">Next
            </CustomButton>
        </BaseButtonGroup>
    </div>
</template>



<script>
import { mapActions } from 'vuex';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import * as COMMONS from '../../store/_commons';
import CustomButton from '../CustomButton.vue';

export default {
  name: 'OtherDetails',
  components: {
    BaseButtonGroup,
    CustomButton
  },
  data() {
    return {
      mfaType: '',
      errorMsg: ''
    }
  },
  computed: {
    loginType() {
      return this.$store.state.guestLogin.loginTypeId;
    },
    contactInfo() {
      return this.$store.state.guestLogin.loginUserDetails;
    }
  },
  created() {

  },
  mounted() {
    window.scroll(0,0);
    document.body.setAttribute("tabindex", "1");
    document.body.focus();

    document.body.removeAttribute("tabindex");
    document.getElementById("app").scrollTop = 0;
  },
  methods: {
    ...mapActions({
      getGuestLoginMfaRequest : COMMONS.GUEST_LOGIN_GET_LOGIN_MFA_REQUEST,
    }),

    async handleRouting(info) {
      if(info=='previous') {
        if(this.contactInfo.email!='' || this.contactInfo.phone!='') {
          this.$store.state.guestLogin.mfaStep = 1;
        }
        else{
          if(this.contactInfo.isPaperOtpSent) {
            this.$store.state.guestLogin.mfaStep = 2;
          }else{
            this.$router.push({name: 'GuestSignin'});
          }
        }
      }
      else {
        if(this.mfaType != '' && this.mfaType != null) {
          if(this.mfaType == 4) {
              let payloadData = {
              mfaType: this.mfaType,
            }
            await this.getGuestLoginMfaRequest(payloadData);
            this.$store.state.guestLogin.mfaType = this.mfaType;
          }  
          if(this.mfaType == 3) {
            let payloadData = {
              mfaType: this.mfaType,
            }
            await this.getGuestLoginMfaRequest(payloadData);
          }
          if(this.mfaType !=3 && this.mfaType!=4){
            this.$router.push({name: 'GuestSignin'});
          }
        }
        else {
          this.errorMsg = 'Please select one of the options above'
        } 
      } 
    },

    // maskAddress(str) { 
    //   const indexOfAt = str.length; 
    //   // if (indexOfAt <= 2) { 
    //   //   return str; 
    //   // }
    //   return str[0] + '*'.repeat(indexOfAt - 1) + str.substring(indexOfAt);
    // }
  }
}
</script>


<style lang="scss" scoped>

.app-button-group{
    margin-top: 1rem;
}
.input-row {
  .user-mail-address-heading{
    font-weight: bold;
  }
}
.otp{
  position: absolute;
}
.otp-text{
  margin-left: 1rem;
  display: block;
  cursor: default !important;
  .user-address{
    line-height: 2rem;
    word-wrap: break-word; 
    span {
      display: block;
      line-height: 30px;
    }
  }
}
.error-msg{
  color: var(--ri-red);
}
</style>